<ul>
    <li>
        <a routerLink="/wheels" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Wheels</a>
        <a routerLink="/accessories" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Accessories</a>
        <a [routerLink]="['/wheels']" [queryParams]="{ clearance: true }" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Clearance</a>
    </li>
</ul>
